import { useShowFirstCaptionTrack } from "@/views/Wiki/utils/useShowFirstCaptionTrack";

type WikiVideoProps = {
  src: string;
  captionsSrc?: string;
  muted?: boolean;
  controls?: boolean;
  autoPlay?: boolean;
  loop?: boolean;
  className?: string;
  wrapperClassName?: string;
  videoClassName?: string;
};

export function WikiVideo({
  src,
  captionsSrc,
  muted = false,
  controls = true,
  autoPlay = false,
  loop = false,
  className,
  wrapperClassName,
  videoClassName,
}: WikiVideoProps) {
  const showCaptionsOnLoad = useShowFirstCaptionTrack();

  return (
    <div
      className={`mb-6 flex justify-center overflow-hidden rounded-xl ${wrapperClassName ?? ""}`}
    >
      <video
        className={`block w-full max-w-240 rounded-xl ${className ?? ""} ${videoClassName ?? ""}`}
        controls={controls}
        autoPlay={autoPlay}
        muted={muted}
        loop={loop}
        playsInline
        preload="metadata"
        crossOrigin="anonymous"
        onLoadedMetadata={captionsSrc ? showCaptionsOnLoad : undefined}
      >
        <source src={src} type="video/mp4" />
        {captionsSrc ? (
          <track
            kind="captions"
            src={captionsSrc}
            srcLang="en"
            label="English"
            default
          />
        ) : null}
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
